import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import tr from './tr.json';
import en from './en.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en'],
    resources: {
      tr: { translation: tr },
      en: { translation: en },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

/** The <title> is plain HTML, so it has to be set whenever the language changes. */
function applyDocumentTitle(): void {
  if (typeof document === 'undefined') return;
  document.title = `${i18n.t('app.name')} — ${i18n.t('app.tagline')}`;
}

/**
 * <html lang> is hardcoded in index.html and otherwise never updates, so
 * native controls that key off it — e.g. Chromium's date-input placeholder
 * ("gg.aa.yyyy" vs. "mm/dd/yyyy") — stay in the initial language even after
 * the in-app language switcher changes everything else.
 */
function applyDocumentLang(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = i18n.language;
}

i18n.on('languageChanged', applyDocumentTitle);
i18n.on('languageChanged', applyDocumentLang);
applyDocumentTitle();
applyDocumentLang();

export default i18n;
